import { render, staticRenderFns } from "./sc-tabs.vue?vue&type=template&id=507273d3&scoped=true&"
import script from "./sc-tabs.vue?vue&type=script&lang=js&"
export * from "./sc-tabs.vue?vue&type=script&lang=js&"
import style0 from "./sc-tabs.vue?vue&type=style&index=0&id=507273d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507273d3",
  null
  
)

export default component.exports